<template>
  <p class="font-size-control">
    <component v-bind:is="'span'" v-for="(text, idx) in texts" :key="idx">
      <br v-if="text.isFirst && idx > 0" />
      <br v-if="text.isFirst && idx > 0" />
      <span
        v-bind:class="{
          'active': isSentActived(text),
          'clickable': true,
          'first': text.isFirst
        }"
        v-html="isContains(text.text)"
        @click="$emit('selectSentId', idx, text.text)"></span>
    </component>
  </p>
</template>

<script>
  export default {

    name: 'Articles',

    props: {
      currentTime: {
        type: Number,
        required: false,
        default: 0
      },

      texts: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      },

      slow: {
        type: Boolean,
        required: false,
        default: false
      },

      highlight: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      }
    },

    data () {
      return {
        sents: []
      }
    },

    methods: {
      isSentActived (sent) {
        var begin = (this.slow) ? sent.timeCode_Slow.begin : sent.timeCode_Normal.begin
        var end = (this.slow) ? sent.timeCode_Slow.end : sent.timeCode_Normal.end
        return this.currentTime >= (begin / 1000) && this.currentTime < (end / 1000)
      },

      isContains (text) {
        var arr = this.highlight || []
        arr.forEach((e) => {
          if (text.indexOf(e.name) > -1) {
            var re = new RegExp('[^<span(.+?)class=/"highlight/">|^a-zA-Z]' + e.name + '[a-z]*[^</span>]', 'i')
            var replace = re.exec(text)
            text = replace ? text.replace(replace[0], '<span class="highlight"> ' + replace[0] + ' </span>') : text
          }
        })

        return text
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/color.scss";

  p {
    margin-bottom: 0;
    padding: 1em;
    border: 1px solid #ccc;
    background-color: #fff;
    text-align: justify;
    text-justify: inter-ideograph;
  }

  .active {
    background-color: $article-active;
    padding: 3px;
    border-radius: 3px;

    .role-name {
      color: #fff;
    }
  }

  .first {
    padding-left: 1.2em;
  }

  .role-name {
    color: $role-name;
  }

  .highlight {
    color: red;
  }

  .clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Articles.vue?6e8df551